import {
   
    SAVE_SESSION_STARTED,
    SAVE_SESSION_COMPLETED,
    SAVE_SESSION_FAILED,
    GET_SESSION_STARTED,
    GET_SESSION_COMPLETED,
    GET_SESSION_FAILED
   
} from '../actions/Session';

const intialSESSIONData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    SESSIONInput: {       
        userId: "",
        password: "",
        securityQuestion: "",
        answer: "",
        roleFkId:{roleId:0,roleName:"",description:"",status:0,createdAt:"",createdBy:"",updatedAt:"",updatedBy:""},
        status:0,
        createdAt:"",
        createdBy:"",
        updatedAt:"",
        updatedBy:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};
export const SESSIONData = (state = intialSESSIONData, action: any) => {
     
    switch (action.type) {
       
        case SAVE_SESSION_STARTED:
           // alert("check");
           return {
                ...state,
                isLoading: true,    
                isFormSubmit:true,
                SESSIONInput: action.input
                
            };

        case SAVE_SESSION_COMPLETED:
             return {
                ...state,
                isLoading: false,
                isFormSubmit:true,
                status: action.payload
                };
            
        case SAVE_SESSION_FAILED:
            return {
                ...state,
                isLoading: true,
            };
            case GET_SESSION_STARTED:          
            return {
                ...state,
                isLoading: true,    
                isFormSubmit:true,
                loginInput: action.input
            };
          case GET_SESSION_COMPLETED:
            return {
                ...state,
                isLoading: false,
                isFormSubmit:true,
                status: action.payload
            };
          case GET_SESSION_FAILED:
            return {
                ...state,
                isLoading: true,
            };
        default:
            return state;
    }
};



